import { lazy } from 'react';

export const path = '/admin';

export const component = lazy(() => import('./Admin'));
